import React from "react";
import { Box, Card, Typography, Tooltip } from "@mui/material";

import TimelineIcon from "@mui/icons-material/Timeline";
import DataSourceIcon from "../../Components/DataSourcesPanel";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip as ChartTooltip,
  ResponsiveContainer,
} from "recharts";

const InteractionTimelineCard = ({
  theme,
  timelineData,
  primaryStart,
  primaryEnd,
}) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        p: { xs: 3, lg: 4 },
        display: "flex",
        flexDirection: "column",
        background: `linear-gradient(135deg, ${primaryStart}, ${primaryEnd})`,
        boxShadow: "0 18px 35px rgba(15,23,42,0.35)",
        color: "#ffffff",
      }}
    >
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <TimelineIcon />
          <Tooltip
            title="Engagement trend derived from meeting counts by month (fallback: meeting highlights)."
            arrow
          >
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1.25rem",
                cursor: "help",
                color: "white",
              }}
            >
              Interaction Timeline
            </Typography>
          </Tooltip>
          <DataSourceIcon mode="dark" sources={["Salesforce Events"]} />
        </Box>
        <Typography sx={{ opacity: 0.85, fontSize: "0.85rem", color: "white" }}>
          Number of meetings per month.
        </Typography>
      </Box>

      <Box sx={{ height: 260 }}>
        {timelineData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={timelineData}>
              <defs>
                <linearGradient
                  id="interactionGradient"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="0%"
                    stopColor="rgba(191,219,254,0.9)"
                    stopOpacity={0.9}
                  />
                  <stop
                    offset="100%"
                    stopColor="rgba(191,219,254,0)"
                    stopOpacity={0}
                  />
                </linearGradient>
              </defs>

              <XAxis
                dataKey="label"
                tick={{ fill: "#fff" }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                allowDecimals={false}
                tick={{ fill: "#fff" }}
                axisLine={false}
                tickLine={false}
              />

              <ChartTooltip
                contentStyle={{
                  backgroundColor: "rgba(15,23,42,0.9)",
                  borderRadius: 8,
                  border: "none",
                  color: "#ffffff",
                  fontSize: "0.8rem",
                }}
                formatter={(value) => [`${value} meetings`, "Count"]}
                labelFormatter={(label) => label}
              />

              <Area
                type="monotone"
                dataKey="count"
                stroke="rgba(191,219,254,1)"
                strokeWidth={3}
                fill="url(#interactionGradient)"
                dot={{
                  r: 5,
                  stroke: "rgba(191,219,254,1)",
                  fill: "#ffffff",
                }}
              />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              fontSize: "0.85rem",
              opacity: 0.85,
            }}
          >
            No interaction data available yet.
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default InteractionTimelineCard;
